import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, throwError, map, catchError } from "rxjs";
import { AppConfigService } from "./app-config.service";
import { MaintenanceError } from "./common/errors/MaintenanceError";
import { RequestIdError } from "./common/errors/RequestIdError";
import { Logger } from "./common/logger";
import { AppServerErrorModel, HttpRespModel } from "./model";
import { AppNeedPayError, AppServerError, AppUnauthorizedError } from "./common/errors";


export class AbstractDataService {
  apiURL: String;
  logger: Logger = Logger.Instance;

  constructor(private http: HttpClient, public router: Router, public config: AppConfigService) {
    this.apiURL = config.getConfig().api;

    // configure logger object
    this.logger.CargoId = config.getValue("cargoId")
    if (config.getValue("logAPI")) this.logger.API_URL = config.getValue("logAPI");
    if (config.getValue("logLevel")) this.logger.LogLevel = config.getValue("logLevel");
  }

  protected requestPostData(methodName: string, params: any, methodType: string, token: string | null = null) {
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.append("Authorization", `Bearer:${token}`);
    }

    return this.http.request<HttpRespModel>(methodType, methodName, { 
      body: params, 
      withCredentials: false,
      headers: headers, 
    });
  }

  protected requestGetData(methodName: string, params: any, token: string | null = null) {
    params.toString = () => {
      let result = '';
      let delimiter = '';
      Object.keys(params).forEach(key => {
        if (typeof (params[key]) !== 'function') {
          result += `${delimiter}${key}=${params[key]}`;
          delimiter = '&';
        }
      });

      return result;
    }

    let headers = new HttpHeaders();
    if (token) {
      headers = headers.append("Authorization", `Bearer:${token}`);
    }

    const paramsStr = params.toString();
    return this.http.get<HttpRespModel>(`${methodName}${paramsStr == "" ? "" : "?"+paramsStr}`, {
      withCredentials: false,
      headers: headers,
    });
  }

  protected requestData(methodName: string, params: any, methodType: string = "get", token: string | null = null): Observable<any> {
    const router = this.router;

    function handleError(error: any): Observable<Error> {
      const logger: Logger = Logger.Instance;
      let appError: AppServerErrorModel;

      switch (error.status) {
        case 0:
          // todo: check
          // A client-side or network error occurred. Handle it accordingly.
          logger.error('requestData_error', error, params);
          break;
        case 400:
          appError = error.error.data as AppServerErrorModel
          //logger.error('requestData_error', error.toString(), params);
          return throwError(() => new AppServerError(appError))
        case 401:
          appError = error.error.data as AppServerErrorModel
          //logger.error('requestData_error', error.toString(), params);
          //router.navigate(["/"]);
          return throwError(() => new AppUnauthorizedError(appError));
        case 402:
          appError = error.error.data as AppServerErrorModel
          return throwError(() => new AppNeedPayError(appError))
        case 503:
          window.location.href = '/';
          return throwError(() => new MaintenanceError('Производятся работы по обновлению сайта. Пожалуйста попробуйте позже.'));
        default:
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong.
          logger.error('requestData_error', error.toString(), params);
      }

      return throwError(() => new Error(error.message));
    }

    let result;
    const requestUUID = params.uuid;
    // const config = this.config.getConfig();

    params = !params ? {} : params;
    // if (config && config.cargoId) {
      // params.cargo_id = config.cargoId;
    // }

    switch (methodType) {
      case "post":
      case "put":
      case "delete": {
        result = this.requestPostData(`${this.apiURL}${methodName}`, params, methodType, token);
        break;
      }
      default: {
        result = this.requestGetData(`${this.apiURL}${methodName}`, params, token);
      }
    }

    return result.pipe(
      map((data: HttpRespModel) => {
        switch (data.result) {
          case "ok": {
            if (requestUUID && data.uuid !== requestUUID) {
              this.logger.log('Wrong UUID for request:', methodName);
              throw new RequestIdError(
                JSON.stringify({ error: "Wrong request ID.", methodName })
              );
            }

            return data.data;
          }
          case "nologin": {
            this.router.navigate(["/login"]);
            return null;
          }
          default: {
            this.logger.log('An error occurred:', data.result);
            throw new Error(
              JSON.stringify({ error: data.result, data: data.data })
            );
            // return Observable.throw({error: data.result, data: data.data})
          }
        }
      }),
      catchError(handleError)
    );
  }
}